import { getCurrentPageDepth } from 'redux/modules/page/selectors';
import {
  getGridItems,
  getPageTitle,
  getSearchAndBrowseLoading,
} from 'redux/modules/search-and-browse/selectors';
import { getLocationsLoading } from 'redux/modules/content/selectors';
import {
  getMetaDataDescription,
  getMetaDataKeywords,
  getMetaDataTitle,
} from 'redux/modules/search-and-browse/selectors/meta-data';
import { getOffersCanonicalHref } from 'redux/modules/taxonomy/selectors';
import { getOffersRelatedNavigation } from 'redux/modules/offers/selectors';
import { getCustomerSlotBranchId } from 'redux/modules/customer-slot/selectors';
import { getPageNotFound } from 'redux/modules/cms-page/selectors';

import mapSubCategories from './map-sub-categories';
import generateOffersBreadCrumbs from './generate-offers-breadcrumbs';

const getBaseOffersPageProps = (state, props) => ({
  breadcrumbs: generateOffersBreadCrumbs(state),
  canonicalHref: getOffersCanonicalHref(state, props),
  locationsLoading: getLocationsLoading(state),
  productsLoading: getSearchAndBrowseLoading(state),
  metaDescription: getMetaDataDescription(state),
  metaKeywords: getMetaDataKeywords(state),
  metaTitle: getMetaDataTitle(state),
  navigation: getOffersRelatedNavigation(state),
  products: getGridItems(state),
  subCategories: mapSubCategories(state, props),
  title: getPageTitle(state),
  taxonomyLevel: getCurrentPageDepth(state),
  customerSlotBranchId: getCustomerSlotBranchId(state),
  pageNotFound: getPageNotFound(state),
});

export default getBaseOffersPageProps;
